<template>
  <el-select v-model="value" filterable clearable :placeholder="$t('clcd1')" :size="size" @change="selectDevice">
    <el-option v-for="item in list" :key="item.value" :label="item.name" :value="item.id" :disabled="!item.run_state && isDisabled" :class="{fontred:item.run_state===0,fontgreen:item.run_state!==0}">
    </el-option>
    <!-- <el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value" :disabled="item.disabled" :class="{fontred:item.disabled==true,fontgreen:item.disabled==false}"> -->
  </el-select>
</template>

<script>
export default {
  name: "DeviceList",
  props: {
    groups: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "mini"
    },
    selectDeviceId: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      groupIds: sessionStorage.getItem('group_ids'),
      deviceCount: 0,
      list: [],
      value: ''
    };
  },
  created() {
    this.getDeviceList();
  },
  methods: {
    async getDeviceList() {
      await this.$http.post("/admin/device/getDeviceNumber", { group_ids: this.groupIds }, data => {
        this.deviceCount = 0;
        data.runState.forEach(d => {
          this.deviceCount += d.number;
        });
      });
      await this.$http.post("/admin/device/list", { page: 1, group_ids: this.groupIds, limit: this.deviceCount }, data => {
        this.list = data.list;
      });
    },
    selectDevice(val) {
      this.$emit('selectDevice', val);
    }
  },
  watch: {
    selectDeviceId: {
      handler(nVal) {
        this.value = nVal;
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.fontred {
  color: red;
}
.fontgreen {
  color: green;
}
</style>